import React, { useState } from 'react';
import { Container, Typography } from '@design-system';
import './MinimalHeaderToggle.scss';

type MinimalHeaderToggleProps = {
    children: React.ReactNode[];
    labels: string[];
    onToggle?: (index: number) => void;
};

type MinimalHeaderButtonProps = {
    label: string;
    isActive: boolean;
    onClick: () => void;
};

const MinimalHeaderButton: React.FC<MinimalHeaderButtonProps> = ({ label, isActive, onClick }) => {
    return (
        <button type="button" className={`minimal-header-toggle-button ${isActive ? 'active' : ''}`} onClick={onClick}>
            <Typography intrinsic="h4">{label}</Typography>
        </button>
    );
};

export const MinimalHeaderToggle: React.FC<MinimalHeaderToggleProps> = ({ children, labels, onToggle }) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);

    const handleToggle = (index: number) => {
        setActiveIndex(index);
        onToggle?.(index);
    };

    return (
        <div className="minimal-header-toggle-wrapper">
            <div className="minimal-header-toggle-buttons-wrapper">
                <Container className="minimal-header-toggle-buttons" data-active={activeIndex}>
                    {labels.map((label, index) => (
                        <MinimalHeaderButton
                            key={label}
                            label={label}
                            isActive={activeIndex === index}
                            onClick={() => handleToggle(index)}
                        />
                    ))}
                </Container>
            </div>

            <div className="minimal-header-toggle-content">{React.Children.toArray(children)[activeIndex]}</div>
        </div>
    );
};
